module.exports = __webpack_public_path__ + "static/media/maintainIcon.1a97a49e.svg";